import {
  fromCognitoIdentityPool,
  FromCognitoIdentityPoolParameters,
} from "@aws-sdk/credential-providers";

import { currentAuthenticatedUser } from "../auth";
import { awsconfig } from "../utils/util";

const cognitoProvider = async () => {
  const userPoolId = `cognito-idp.${awsconfig.aws_cognito_region}.amazonaws.com/${awsconfig.aws_user_pools_id}`;

  const parameters: FromCognitoIdentityPoolParameters = {
    clientConfig: {
      region: awsconfig.aws_cognito_region,
    },
    identityPoolId: awsconfig.aws_cognito_identity_pool_id,
  };

  try {
    const currentUser = await currentAuthenticatedUser();
    if (currentUser == null) {
      return;
    }
    parameters.logins = {
      [userPoolId]: currentUser?.signInUserSession.getIdToken().getJwtToken(),
    };
  } catch (e) {
    console.error(e);
  }

  const provider = fromCognitoIdentityPool(parameters);
  return provider();
};

export default function createAwsClient<TClient, TConfig>(
  client: new (config: NonNullable<TConfig>) => TClient,
  config?: TConfig,
) {
  return new client({
    credentials: cognitoProvider,
    region: awsconfig.aws_project_region,
    ...(config ?? {}),
  } as any);
}
